export default {
      id: "arrow-right-usage",
      viewBox: "0 0 4 6",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#arrow-right-usage",
      toString: function () {
        return this.url;
      }
    }